import WagtailBlocksSection from '@components/global/Blocks/WagtailBlocksSection'
import NoResults from '@components/MediaHub/NoResults'
import { getChildPages } from '@lib/api-services/cmsService'
import { apiFieldsQuery, defaultImages, itemShowPerPage } from '@lib/variables'
import { Container, Section } from '@styles/global.styled'
import HeroSection from 'components/global/Blocks/Hero'
import ResourceList from 'components/MediaHub/ResourceList'
import { NextSeo } from 'next-seo'
import { useRef, useState } from 'react'

const ResourcesIndexPage = (props) => {
  const { pageData, queryParams, meta } = props
  const [items, setItems] = useState(props.items || [])
  const [page, setPage] = useState(queryParams.page || 1)
  const [loading, setLoading] = useState(false)
  const formRef = useRef(null)

  const metaTitle = meta.meta_title || pageData.title
  const metaDescription = meta.meta_description || pageData.hero_text
  const ogTitle = meta.og_title || metaTitle
  const ogDescription = meta.og_description || metaDescription
  const ogImage = meta.og_img
    ? [{ url: meta.og_img }]
    : pageData.hero_image?.url
    ? [{ url: pageData.hero_image?.url }]
    : [{ url: defaultImages.mediumNavy }]

  const getResources = async (value) => {
    setLoading(true)
    try {
      const resp = await getChildPages(
        queryParams.type,
        queryParams.parentId, //child_of
        queryParams.limit,
        page,
        {
          ...queryParams.params,
          search: value,
          order: 'title',
        },
        queryParams.fields
      )

      if (resp.items) {
        return resp
      }
    } catch (error) {
      // Handle the error here
      console.error('An error occurred while fetching the data:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async (values) => {
    const ressults = await getResources(values?.search)
    const itemsData =
      ressults &&
      ressults.items.map((item) => {
        return {
          ...item,
          id: item.id,
          title: item.title,
          description: item.description,
          type: item.resource_type,
          imgUrl: item.image_thumbnail ? item.image_thumbnail.url : null,
          link: {
            label: '',
            url: item.resource_path,
          },
        }
      })

    setItems(itemsData)
  }

  const handleClearSearch = async () => {
    formRef.current && formRef.current.resetForm()
    await handleSubmit({ search: '' })
  }

  return (
    <>
      <NextSeo
        title={metaTitle}
        description={metaDescription}
        openGraph={{
          images: ogImage,
          title: ogTitle,
          description: ogDescription,
        }}
      />
      <HeroSection
        title={pageData.title}
        description={pageData.hero_text}
        bgImageUrl={pageData.hero_image?.url}
        bgPosition={pageData.hero_image_anchor}
      />

      <Section>
        <Container>
          {items && items.length > 0 ? (
            <ResourceList items={items} />
          ) : (
            <NoResults onClearSearch={handleClearSearch} />
          )}
        </Container>
      </Section>
      <WagtailBlocksSection blocks={pageData.content_blocks} />
    </>
  )
}

ResourcesIndexPage.getInitialProps = async (ctx, pageData) => {
  const queryParams = {
    type: 'media_hub.Resource',
    parentId: pageData.id,
    limit: itemShowPerPage.ResourcesIndexPage,
    page: 1,
    params: { order: 'title' },
    fields: apiFieldsQuery.resourcesPage,
  }

  let childrenPages = await getChildPages(
    queryParams.type,
    queryParams.parentId,
    queryParams.limit,
    queryParams.page,
    queryParams.params,
    queryParams.fields
  )

  return {
    queryParams,
    items:
      childrenPages.items &&
      childrenPages.items.map((item) => {
        return {
          ...item,
          id: item.id,
          title: item.title,
          description: item.description,
          type: item.resource_type,
          imgUrl: item.image_thumbnail ? item.image_thumbnail.url : null,
          link: {
            label: '',
            url: item.resource_path,
          },
        }
      }),
    meta: childrenPages.meta || {},
  }
}
export default ResourcesIndexPage
